import axios from 'axios'

const API_URL = process.env.REACT_APP_API_URL

export type BulkVosSettingsDto = {
  isEnabled: boolean
  recipients?: string
  scheduleTimeLocal?: string
  repeatInterval: number
  repeatUnit: number
  repeatDaysOfWeek: number
  repeatDayOfMonth?: number
  endsType: number
  endsOnDate?: string
  endsAfterOccurrences?: number
  timeZoneId?: string
  includeManualVos: boolean
  includeDigitalVos: boolean
  includeIpi: boolean
  includeVis: boolean
  scheduleSummary?: string
}

export async function fetchBulkVosSettings(customerId: number): Promise<BulkVosSettingsDto> {
  const {data} = await axios.get(`${API_URL}/CustomerSettings/bulk-vos/${customerId}`)
  return data
}

export async function saveBulkVosSettings(customerId: number, body: BulkVosSettingsDto): Promise<void> {
  await axios.put(`${API_URL}/CustomerSettings/bulk-vos/${customerId}`, body)
}
